import { render, staticRenderFns } from "./menu1_1.vue?vue&type=template&id=128e155f&scoped=true&"
import script from "./menu1_1.vue?vue&type=script&lang=js&"
export * from "./menu1_1.vue?vue&type=script&lang=js&"
import style0 from "./menu1_1.vue?vue&type=style&index=0&id=128e155f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128e155f",
  null
  
)

export default component.exports